// File: cgp-user-profile-dialog-module.ts
// Author: James L Seebach
// Date: 5/12/2017
// Desc: CGP User Profile module.
// Other Contributors:
import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatChipsModule } from '@angular/material/chips';
import { CgpUserProfileDialogComponent } from "./cgp-user-profile-dialog.component";
import { CgpUserProfileDialogService } from "./cgp-user-profile-dialog.service";
import { UserProfileService } from '../../components/mesc/mesc.service';
import { PipesModule } from '../pipes/pipes.module';

@NgModule({
    imports: [
        MatDialogModule,
        MatButtonModule,
        MatChipsModule,
        CommonModule,
        PipesModule,
    ],
    exports: [
        CgpUserProfileDialogComponent
    ],
    declarations: [
        CgpUserProfileDialogComponent
    ],
    providers: [
        CgpUserProfileDialogService, UserProfileService, DatePipe
    ]
})
export class CgpUserProfileDialogModule { }
